<script>
  import { page } from '$app/stores';
  import ErrorPageLayout from '$lib/components/website/pageLayout/ErrorPageLayout.svelte';
</script>

<svelte:head>
  <title>Sweat - Page not found</title>
</svelte:head>

{#if $page?.error?.message === '404'}
  <ErrorPageLayout
    title="Oops! Page not found"
    subTitle="Looks like you've taken a wrong turn on your fitness journey, let's get you back on track"
    fontSize="text-lg sm:text-2xl"
  >
    <a
      href="/"
      class="text-center mr-0 mb-3 sm:mb-0 sm:mr-8 px-0 sm:px-10 w-full sm:w-auto py-3 font-semibold border focus:outline-0 focus:shadow-button bg-primary-500 border-primary-500 text-white rounded-full hover:bg-primary-700 focus:shadow-sweat-pink-0"
      >Back to home</a
    >
    <a
      href="/blogs/news"
      class="text-center w-full sm:w-auto px-0 sm:px-8 py-3 border focus:outline-0 focus:shadow-button font-semibold bg-white border-gray-300 text-gray-700 rounded-full hover:bg-gray-50 hover:text-gray-800 focus:shadow-gray-100/95"
      >Explore articles</a
    >
  </ErrorPageLayout>
{:else}
  <ErrorPageLayout
    title="Rest period in progress"
    subTitle="We know how important it is to rest and recharge, and sometimes we need to take a quick break to improve our performance. Our website is currently having some technical difficulties but we'll be back stronger than ever very soon!"
    fontSize="text-lg sm:text-xl"
  ></ErrorPageLayout>
{/if}
